import ReportingService from "Lib/API/Report";
import React, { useEffect, useState } from "react";
import { TableReport } from "./Table";

import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@material-ui/core";

import AlertDialog from "components/Dialog/index";
import { toastr } from "react-redux-toastr";
import styled from "styled-components";
const Box = styled.div`
  background: #ffffff;
  min-height: 100vh;
  padding-left: 31px;
  padding-right: 26px;
  padding-top: 24px;

  > div {
    display: flex;
    justify-content: flex-start;
  }
`;

const TotalReport = styled.span`
  color: #4f4f4f;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  margin-bottom: 17px;
`;
export const ReportsList = ({
  setId,
  selectedId,
  rowsPerPage,
  setRowsPerPage,
  isLoading,
  page,
  setPage,
  getReports,
  count,
  data,
  filters,
  sortReport,
  setDuolicatetModal,
  setDuolicatetData,
  toggle,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [favLoading, setFavLoading] = useState(false);
  const [publicLoading, setPublicLoading] = useState(false);
  const [financialReports, setFinancialReports] = useState([]);
  const [confirmDelete, setConfirmDelete] = useState({
    open: false,
    id: "",
    loading: false,
  });

  const onChange = async (e) => {
    const { checked, value } = e.target;
    setPublicLoading(true);
    const token = await getAccessTokenSilently();
    if (checked) {
      ReportingService.addPublic(token, { filterId: value, is_public: true })
        .then((res) => {
          getReports();
          setPublicLoading(false);
        })
        .catch((err) => {
          setPublicLoading(false);
            toastr.error('Error', err?.data?.message);
        });
    } else {
      setPublicLoading(true);

      ReportingService.addPublic(token, { filterId: value, is_public: false })
        .then((res) => {
          getReports();
          setPublicLoading(false);
        })
        .catch((err) => {
          setPublicLoading(false);
          toastr.error('Error', err?.data?.message);
        });
    }
  };

 
  const onFave = async (id, value) => {
    setFavLoading(true);
    const token = await getAccessTokenSilently();
    if (value === true) {
      ReportingService.addFavourite(token, {
        filterId: id,
        is_favourite: value,
      })
        .then((res) => {
          getReports();
          setFavLoading(false);
        })
        .catch((err) => {
          setFavLoading(false);
          toastr.error('Error', err?.data?.message);
        });
    } else {
      ReportingService.addFavourite(token, {
        filterId: id,
        is_favourite: value,
      })
        .then((res) => {
          getReports();
          setFavLoading(false);
        })
        .catch((err) => {
          setFavLoading(false);
          toastr.error('Error', err?.data?.message);
        });
    }
  };
  
  const handleDeleteReport = async () => {
    setConfirmDelete(prevState => ({ ...prevState, loading: true })); 
    const token = await getAccessTokenSilently();
    ReportingService.deleteFilter(token, { filterId: confirmDelete.id })
      .then((res) => {
        getReports();
        setConfirmDelete(prevState => ({ ...prevState, loading: false, open: false })); 
      })
      .catch((err) => {
        setConfirmDelete(prevState => ({ ...prevState, loading: false, open: false })); 
        toastr.error('Error', err?.data?.message);
      });
  }
  
  const deleteFilter =  (id) => {
    setConfirmDelete({ open: true, id: id, loading: false });
  };

  const closeDeleteModal = () => {
    setConfirmDelete({ open: false, id: "", loading: false });
  }

  const handleChangePage = (_, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 30));
    setPage(0);
  };
  useEffect(() => {
    localStorage.setItem("goto", "parameter");
  }, []);
  return (
    <Box className="col-mb-12 col-xs-12 col-lg-12 col-sm-12 ">
      {!isLoading && <TotalReport>{`${
        toggle !== "Financial Reports" ? count : financialReports?.length || ""
      } ${toggle !== "Financial Reports" ? "Segments" : "Reports"}`}</TotalReport>}
      <TableReport
        toggle={toggle}
        setId={setId}
        selectedId={selectedId}
        isLoading={isLoading}
        favLoading={favLoading}
        deleteLoading={confirmDelete.loading}
        publicLoading={publicLoading}
        setDuolicatetData={setDuolicatetData}
        setDuolicatetModal={setDuolicatetModal}
        deleteFilter={deleteFilter}
        filters={filters}
        sortReport={sortReport}
        data={data}
        onChange={onChange}
        onFave={onFave}
        page={page}
        count={count}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        financialReports={financialReports}
        setFinancialReports={setFinancialReports}
        getReports={getReports}
      />
       <AlertDialog
          open={confirmDelete.open}
          onDecline={closeDeleteModal}
          onAccept={handleDeleteReport}
          title={`Are you sure?`}
          description={"Do you want to delete this report?"}
          disabled={confirmDelete.loading}
        />
    </Box>
  );
};
